import { useState } from "react";
import schedule from "../../data/schedule";
import SectionHeading from "../common/SectionHeading";
import "./ScheduleSection.css";

const DAYS = Object.keys(schedule);

export default function ScheduleSection() {
  const [activeDay, setActiveDay] = useState(DAYS[0]);

  return (
    <section className="schedule-section section">
      <div className="container">
        <SectionHeading
          eyebrow="Weekly Schedule"
          title="Plan your"
          highlight="training week"
          description="Sample session timings — confirm current class hours with the front desk before relying on this schedule."
        />

        <div className="schedule-section__filters" role="tablist" aria-label="Choose a day">
          {DAYS.map((day) => (
            <button
              key={day}
              type="button"
              role="tab"
              aria-selected={activeDay === day}
              className={`schedule-section__filter ${activeDay === day ? "schedule-section__filter--active" : ""}`}
              onClick={() => setActiveDay(day)}
            >
              {day.slice(0, 3)}
            </button>
          ))}
        </div>

        <div className="schedule-section__table" role="tabpanel">
          {schedule[activeDay].map((slot) => (
            <div className="schedule-section__row" key={`${activeDay}-${slot.time}`}>
              <span className="schedule-section__time">{slot.time}</span>
              <span className="schedule-section__session">{slot.session}</span>
              <span className="schedule-section__day">{activeDay}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
